import { http } from '../request'
import type {
    AdminRefundListRequest,
    AdminRefundListResponse,
    AdminRefundDetailResponse,
    AdminRefundOverviewResponse,
    CreateRefundRequest,
    AdminApproveRefundRequest,
    AdminRejectRefundRequest
} from '../types_admin/refunds'

export const adminRefundsApi = {
    /** 获取退款申请列表 */
    getRefundList(params?: AdminRefundListRequest): Promise<AdminRefundListResponse> {
        return http.list('/api/admin/payments/refunds/', params)
    },

    /** 获取退款管理概览（列表+统计） */
    getRefundOverview(params?: AdminRefundListRequest): Promise<AdminRefundOverviewResponse> {
        return http.get('/api/admin/payments/refunds/overview/', { params })
    },

    /** 获取退款申请详情 */
    getRefundDetail(id: number): Promise<AdminRefundDetailResponse> {
        return http.get(`/api/admin/payments/refunds/${id}/`)
    },

    /** 管理员代客创建退款申请 */
    createRefund(data: CreateRefundRequest) {
        return http.post('/api/payments/refunds/', data)
    },

    /** 审批通过（二次确认弹窗应在调用前做） */
    approveRefund(id: number, data?: AdminApproveRefundRequest) {
        return http.post(`/api/admin/payments/refunds/${id}/approve/`, data)
    },

    /** 审批驳回 */
    rejectRefund(id: number, data?: AdminRejectRefundRequest) {
        return http.post(`/api/admin/payments/refunds/${id}/reject/`, data)
    },
}
